/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../types/graph';

import * as Operations from './mutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type AddInternalCaseTagsMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.LifeApplicationAddInternalCaseTagsMutationInput;
}>;


export type AddInternalCaseTagsMutation = { __typename?: 'Mutation', life_applications: { __typename?: 'LifeApplications', add_internal_case_tags: { __typename?: 'LifeApplication', id: string } | null } };


export function useAddInternalCaseTagsMutation(baseOptions?: Apollo.MutationHookOptions<AddInternalCaseTagsMutation, AddInternalCaseTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInternalCaseTagsMutation, AddInternalCaseTagsMutationVariables>(Operations.AddInternalCaseTags, options);
      }
export type AddInternalCaseTagsMutationHookResult = ReturnType<typeof useAddInternalCaseTagsMutation>;